import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import MainTable from "../../../components/tables/MainTable";
import endpoints from "../../../services/endpoints";
import { TableDetailsItem } from "../../../components/tables/tableFunctions";
import { RootState } from "../../../store";
import { useSelector } from "react-redux";
import usePrivilege from "../../../components/CustomHooks/usePrivilege";

export default function OtherResources() {
  const navigation = useNavigate();
  const { bankList } = endpoints;
  const pathname = useSelector((state: RootState) => state.geolocation.previousUrl);
  const TableDetails: { [key: string]: TableDetailsItem } = {
    "Bank Name": {
      id: "name",
      className: "min-w-[420px]",
    },
    "Bank Account Number": {
      id: "account_number",
    },
    "Account Type": {
      id: "account_type",
      className: "min-w-[250px]",
    },
    "Bank Charge Percentage / AFA": {
      id: "charge_value_with_mode",
    },
    'Actions': {
      sort: false,
      id: "actions",
      className: "min-w-[200px]", // Adding className here
      actionTypes: ["edit"],
    },
  };
  const handleActions = (id: string, key: string) => {
    if(key === 'edit'){
      navigation(`/other-resources/banks/edit-bank/${id}`)
    }
  };
  const addButtonClick = () => {
    navigation("/other-resources/banks/add-bank");
  };
  const staticText = {
    emptyScreenText: {
      heading1: "There are no banks added yet",
      heading2: "Click “Add Bank to create one",
    },
  };
  return (
    <div>
      <Breadcrumbs
        navPath={["Other Resources", "Banks", "List of Banks"]}
        heading="List of Banks"
        noNavigation
        links={pathname ? [pathname] : ["/other-resources/banks"]}
        button={{
          buttonName: "Add Bank",
          className: "w-[130px]",
          buttonOnclick: addButtonClick, // Corrected function type
        }}
        list={true}
      />
      <MainTable
        staticText={staticText}
        mainEndPoint={bankList}
        TableDetails={TableDetails}
        handleActions={handleActions}
        params={{ page_number: "1" }}
        searchPlaceholder={"Search by bank name"}
        filters={false}
        exporting={false}
        displayTotalRecords
        notfoundRoute={{ state: { route: "/other-resources/banks" } }}
        title={"Banks"}
      />
    </div>
  );
}
